module.exports = __webpack_public_path__ + "img/SummaryBanner.03704044.svg";